import { useTranslation } from 'react-i18next';
import { FormField } from '@noor/ui';
import { useFormContext } from 'react-hook-form';
import { measurementTypeLabelKey } from '../config/unit-codes';
import type { ProductFormValues } from '../model/schema';

/**
 * The net amount's suffix comes from `measurement_type`, which is also what
 * customers see alongside the value on a product card.
 */
export function MeasureAmountField({
  className,
  fieldClassName,
}: {
  className?: string;
  fieldClassName?: string;
}) {
  const { t } = useTranslation('eats');
  const measurementType = useFormContext<ProductFormValues>().watch('measurementType');
  const labelKey = measurementTypeLabelKey(measurementType);

  return (
    <FormField name="measureAmount" {...(className ? { className } : {})}>
      <FormField.Label className="flex items-center gap-0.5 text-sm font-medium tracking-tight">
        {t('menu.product.form.measureAmountLabel')}
      </FormField.Label>
      <FormField.Number
        {...(fieldClassName ? { className: fieldClassName } : {})}
        min={0}
        decimals={
          measurementType === 'MEASUREMENT_TYPE_KG' ||
          measurementType === 'MEASUREMENT_TYPE_L'
            ? 3
            : 0
        }
        placeholder={t('menu.product.form.measureAmountPlaceholder')}
        suffix={labelKey ? t(`menu.product.form.units.${labelKey}`) : undefined}
      />
      <FormField.Message />
    </FormField>
  );
}
